// frontend/src/services/opsService.js
import api from './apiService';

export async function exchangeOpsBridgeToken(token) {
  const { data } = await api.post('/assinaturas/ops/auth/', { token });
  return data;
}

export async function getOpsResumo(params = {}) {
  const { data } = await api.get('/assinaturas/ops/resumo/', { params });
  return data;
}

export async function getOpsFaturas(params = {}) {
  const { data } = await api.get('/assinaturas/ops/faturas/', { params });
  return data;
}

export async function syncOpsFaturas(limit = 100) {
  const { data } = await api.post('/assinaturas/ops/sync/', { limit });
  return data;
}

export async function getOpsPrevisao(meses = 6) {
  const { data } = await api.get('/assinaturas/ops/previsao/', { params: { meses } });
  return data;
}

export async function getOpsBreakdown(params = {}) {
  const { data } = await api.get('/assinaturas/ops/breakdown/', { params });
  return data;
}

export async function getOpsTaxas() {
  const { data } = await api.get('/assinaturas/ops/taxas/');
  return data;
}

export async function getOpsAfiliadosPendentes() {
  const { data } = await api.get('/assinaturas/ops/afiliados-pendentes/');
  return data;
}

export async function downloadOpsFaturasCsv(params = {}) {
  const response = await api.get('/assinaturas/ops/faturas/export.csv', {
    params,
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'faturas_ops.csv');
  document.body.appendChild(link);
  link.click();
  link.remove();
}
